import { render } from "./OutletPage.vue?vue&type=template&id=5dd5aa40&lang=pug"
import script from "./OutletPage.vue?vue&type=script&lang=js"
export * from "./OutletPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__